





























import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { IOnboardingMilestoneTemplate, ITrainingMilestoneTemplate, IUser } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import { IAccordionSelectItem, ISelectItem } from '@/interfaces'
import AccordionSelect from '@/components/AccordionSelect.vue'
import Api from '@/api'
import ModalV2 from '@/components/modals/ModalV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { required } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { MilestoneTemplate } from '@/store/types/milestone'

const groupBy = require('lodash.groupby')
const sortBy = require('lodash.sortby')

@Component({
  components: {
    InputValidator,
    SelectV2,
    TextareaV2,
    ModalV2,
    DateInput2,
    AccordionSelect
  },
  props: {
    type: {
      type: String,
      default: 'chain'
    },
    task: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  }
})
export default class NewTaskModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  loggedUser: any = Api.getUser()

  dueDate: string = ''
  template: number | null = null
  category: string | number = ''
  comments: string = ''
  assignedTo: number | null = null

  isLoading: boolean = false

  validations (): any {
    return {
      dueDate: { required },
      assignedTo: { required },
      comments: { required }
    }
  }

  get id () {
    return this.$route.params.id
  }

  get users () {
    return this.$store.state.user.users
  }

  get user () {
    return this.$store.state.user.selectedUser
  }

  get chain () {
    if (this.$props.type === 'user') {
      return this.user.chain
    }
    return this.$store.state.chain.chain
  }

  get userItems () {
    const usersOrder = [
      'Esther Singer',
      'Atara Tashman',
      'Ita Klitnick'
    ].map((name: string) => name.toLocaleLowerCase())

    return sortBy(this.users, (user: IUser) => {
      const index = usersOrder.indexOf(`${user.firstName} ${user.lastName}`.toLocaleLowerCase())
      return index === -1 ? 1000000 : index
    }).map((user: IUser) => {
      return {
        key: user.id,
        value: Number(user.id),
        content: `${user.firstName} ${user.lastName}`
      }
    })
  }

  get milestoneTemplates () {
    if (this.$props.type === 'user') {
      return this.$store.state.chain.trainingTemplates
    }
    return this.$store.state.chain.onboardingTemplates
  }

  get filedPlaceholder () {
    if (this.$props.type === 'user') {
      return 'Training Categories'
    }
    return 'Milestone'
  }

  get milestoneItems () {
    const group = groupBy(this.milestoneTemplates, (template: MilestoneTemplate) => template.parent)
    let milestoneItems: any[] = []
    Object.keys(group).forEach((key) => {
      const parent: MilestoneTemplate = this.milestoneTemplates.find((template: MilestoneTemplate) => template.id === +key)
      if (parent) {
        milestoneItems.push({
          parent,
          title: parent.milestone as string,
          key: key,
          items: sortBy(group[key], (item: any) => item.order).map((template: IOnboardingMilestoneTemplate) => {
            return {
              key: template.id,
              value: template.id,
              content: template.milestone
            }
          })
        })
      }
    })
    return milestoneItems
  }

  mounted () {
    this.isLoading = true

    if (this.$props.isEdit) {
      const task = this.$props.task
      this.dueDate = task.dueDate
      this.category = Number(task.category)
      if (this.$props.type === 'user') {
        this.template = task.trainingMilestone ? task.trainingMilestone.template.id : null
      } else {
        this.template = task.onboardingMilestone ? task.onboardingMilestone.template.id : null
      }
      this.comments = task.task
      this.assignedTo = task.assignedTo.id
    } else {
      const date = new Date()
      date.setHours(6)
      date.setMinutes(0)
      this.assignedTo = this.loggedUser.data.id
      this.dueDate = new Date(date.getTime() + 5 * 24 * 60 * 60 * 1000).toLocaleString()
    }

    this.isLoading = false
  }

  selectMilestone (item: ISelectItem) {
    if (this.$props.type === 'user') {
      this.category = item.value
      this.template = null
    } else {
      this.category = ''
      this.template = item.value
    }
  }

  async submit () {
    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    const data = {
      assignedTo: this.assignedTo,
      category: this.category,
      dueDate: new Date(this.dueDate).getTime()
    }

    this.isLoading = true
    if (this.$props.isEdit) {
      const func = this.$props.type === 'user'
        ? this.chainModuleInstance.updateUserAdminTask
        : this.chainModuleInstance.updateAdminTask
      await func({
        id: this.$props.task.id,
        data: {
          ...data,
          task: this.comments,
          chain: +this.chain.id,
          user: this.$props.type === 'user' ? this.user.id : undefined
        },
        template: this.template || undefined
      })
    } else {
      const func = this.$props.type === 'user'
        ? this.chainModuleInstance.addUserAdminTask
        : this.chainModuleInstance.addAdminTask

      await func({
        ...data,
        userId: this.$props.type === 'user' ? this.user.id : undefined,
        chainId: +this.chain.id,
        template: this.template,
        comments: this.comments
      })
    }
    if (this.$props.type === 'user') {
      await this.chainModuleInstance.fetchUserAdminTasks(this.user.id)
    } else {
      await this.chainModuleInstance.fetchAdminTasks(this.chain.id)
    }
    this.isLoading = false
    this.$emit('close')
  }
}
